var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "club-summary-burns" }, [
    _c("div", { staticClass: "club-summary-burns__inner" }, [
      _c("div", { staticClass: "club-summary-burns__points" }, [
        _vm._v("\n      -" + _vm._s(_vm._f("price")(_vm.points)) + "\n    ")
      ]),
      _c("div", { staticClass: "club-summary-burns__caption" }, [
        _vm._v("\n      сгорают " + _vm._s(_vm.expiresAt) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }